import type { API } from 'chessboard/api/config/types';
import { Core } from 'chessboard/core/config/types';
import { Game } from 'chessboard/model/game/types';
import { isClaimableDraw } from 'chessboard/model/jce/is-claimable-draw';

/**
 * Create the claimDraw method.
 */
export function createClaimDraw(context: API.Context) {
  /**
   * Claim a draw.
   */
  return function claimDraw(): API.Response {
    const { api, game } = context;

    if (api.isGameOver()) {
      return null;
    }

    // Both the 50 move rule and the threefold repetition rule are valid if the
    // situation happens AFTER that player's move. Therefore, for our purposes,
    // either player can claim the draw, because either they have just moved
    // or are about to move when the rule is enacted.
    if (isClaimableDraw(game)) {
      api.setResult(Game.Results.Draw);

      return context.respond(Core.APIEvents.DrawClaimed);
    }

    return null;
  };
}
